import React, {FC, memo} from 'react';

import H1 from '../../../Headings/H1';



import { getPublicUrl } from '../../../../utils/ImageCacheService';
import styled from 'styled-components';
import colors from '../../../../config/colors';

interface IEmployerPrimaryDetails {
    employer: any;
}

const Title: FC<IEmployerPrimaryDetails> = ({employer}) => {
    return (
      employer ?
                
          <EmployerDetails>
            <H1>{employer.company_name} posao</H1>
            {employer.avatar && employer.company_file_name ?
              <span>
                <img src={getPublicUrl(employer.company_file_name)} alt={employer.company_name} />
              </span>
            : employer.company_name}
          </EmployerDetails>
        
      : null
    )
}

const EmployerDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    margin: 0;
  }

  span {
    width: 115px;
    height: 115px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 10px;
    box-shadow: 0 0 20px ${colors.SHADOW_GRAYDARK};
    margin-left: 10px;
  }
  img {
    padding: 10px;
    width: 115px;
    height: 115px;
    object-fit: cover;
  }
`;

export default memo(Title);